import { useEffect, useState } from 'react';

const findInContainer = (container: HTMLElement, id: string | number): HTMLElement | null => {
  const wanted = String(id);
  for (const element of container.querySelectorAll<HTMLElement>('[id]')) {
    if (element.id === wanted) return element;
  }
  return null;
};

const findSection = (container: HTMLElement | null, id: string | number): HTMLElement | null =>
  container ? findInContainer(container, id) : document.getElementById(String(id));

export const useActiveSection = (
  sectionIds: (string | number)[],
  container: HTMLElement | null,
) => {
  const [activeId, setActiveId] = useState<string | number | null>(null);

  useEffect(() => {
    if (!container) return;

    const handleScroll = () => {
      for (const id of sectionIds) {
        const element = findInContainer(container, id);
        if (!element) continue;

        const rect = element.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const offsetTop = rect.top - containerRect.top;

        if (offsetTop >= 0 && offsetTop < container.clientHeight / 2) {
          setActiveId(id);
          break;
        }
      }
    };

    container.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, [sectionIds, container]);

  const handleScrollToSection = (id: string | number) => {
    findSection(container, id)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  };

  return { activeId, handleScrollToSection };
};
